export const getWaterUsagePrograms = (formData:object) =>{
    const waterUsagePrograms: { desc: string; }[] = []
    const formValues = Object.keys(formData);
    formValues.forEach((key: string) => {
      if (key.includes('desc')) {
        const splitArray = key.split('-')
        const index = splitArray[splitArray.length - 1]
        if (formData[`desc-${index}`]) {
          waterUsagePrograms.push({
            desc: formData[`desc-${index}`]
          })
        }
      }
    })
    return waterUsagePrograms
  }


export const Uom = [
    {value: 'gallon', label:'Gallon'},
    {value: 'liter', label:'Liter'},
    {value: 'cubicFeet', label:'CubicFeet'},
    {value: 'cubicMeter', label:'CubicMeter'},
]

export const YesOrNoOptions = [
    {value: 'true', label:'Yes'},
    {value: 'false', label:'No'},
]
